import React, { useState } from 'react'
import { withRouter } from 'withRouter'
import slugify from 'react-slugify'
import remarkGfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import AskVisoSuggestions from '../layout/AskVisoSuggestions'
import Comment, { CommentBubble } from '../../../Comment/index'
import { VuiButton, VuiOptionChip } from '@topkamera/viso-ui'
import { buildMessage } from '../../utils'
import { RenderDemoApp, renderOptionChips, selectOptionChip } from './contentUtils'
import './AskVisoChatMessage.scss'

const AskVisoChatMessage = ({
  message = {}, color, setPromptValue, chatId, isFullscreen, setDeleteModal, dashboardDetails, devicesData, toggleReloadDataOnClose, modeValue, onAskAgent, workspace, router
}) => {
  const [showReasoning, setShowReasoning] = useState(false)
  const { text, introduction, reasoning, suggestions, response, moreToReview, summary, layout, question, options, demoApp } = message?.content || {}
  const messageParams = { response, color, dashboardDetails, devicesData, toggleReloadDataOnClose, layout }

  return (
    <div className={classNames('ask-viso-chat-message', message.senderRole === 'user' && 'ask-viso-chat-message--user')}>
      {message.senderRole === 'user' && <CommentBubble>{text}</CommentBubble>}
      {message.senderRole === 'model' &&
        <Comment
          formatter={() => (
            <div className='ask-viso-markdown'>
              {introduction &&
                <div className='ask-viso-markdown__introduction'>
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>{introduction}</ReactMarkdown>
                </div>
              }
              {summary && summary.length > 0 &&
                <div className='ask-viso-markdown__summary'>
                  <h2>Summary</h2>
                  <ul>
                    {summary.map((item, index) => (<li key={`${item}-${index}`}>{item}</li>))}
                  </ul>
                </div>
              }
              {(modeValue === 'reviewCharts' || modeValue === 'improveCharts') &&
                <div className='ask-viso-markdown__fixes'>
                  <h2>Suggested Fixes</h2>
                </div>
              }
              {modeValue === 'recommendCharts' &&
                <div className='ask-viso-markdown__recommendations'>
                  <h2>Recommended charts</h2>
                </div>
              }
              {buildMessage(messageParams)}
              {question && <ReactMarkdown remarkPlugins={[remarkGfm]}>{question}</ReactMarkdown>}
              {demoApp && (
                <div className='ask-viso-markdown__demo-app vui-pb-4'>
                  <RenderDemoApp
                    data={demoApp}
                    color={color}
                    onViewDemo={(id) => router.navigate(`/${workspace && slugify(workspace.name)}/dashboards/demo/${id}`)}
                  />
                </div>
              )}
              {options?.length > 0 &&
                <div className='ask-viso-markdown__options vui-pb-4'>
                  <VuiOptionChip
                    items={renderOptionChips(options)}
                    color={color}
                    onClick={(value) => selectOptionChip({ option: options[value], onAskAgent, chatId })}
                  />
                </div>
              }
              {moreToReview?.length > 0 &&
                <div className='ask-viso-markdown__more'>
                  <h2>More to review</h2>
                  <ol>
                    {moreToReview.map((more, index) => (<li key={`${more}-${index}`}>{more}</li>))}
                  </ol>
                </div>
              }
            </div>
          )}
          commentFooter={
            <>
              {reasoning && reasoning.length > 0 && showReasoning && (
                <div className='ask-viso-chat-message__reasoning border-left'>
                  <ol>
                    {reasoning.map((reason, index) => (<li key={`${reason}-${index}`}>{reason}</li>))}
                  </ol>
                </div>
              )}
              {question && options?.length === 0 && (
                <div className='vui-flex vui-justify-end'>
                  <VuiButton
                    label='Create options' size='sm'
                    color={color}
                    onClick={() => onAskAgent('Could you create more examples for me', chatId)}
                    style='light'
                    radius='rounded'
                  />
                </div>
              )}
              {suggestions && suggestions.length > 0 &&
                <AskVisoSuggestions
                  suggestions={suggestions}
                  chatId={chatId}
                  isFullscreen={isFullscreen}
                  setPromptValue={setPromptValue}
                  color={color}
                  isFooter
                />
              }
            </>
          }
          contentClass={'ask-viso-chat-message__comment'}
          showAvatar
          hideName
          firstName='A'
          lastName='I'
          color={color}
          text={message.content}
          date={message.updatedAt}
          actions={[
            ...(reasoning && reasoning.length > 0 ? [
              {
                label: 'Reasoning',
                onClick: () => setShowReasoning(!showReasoning),
                color: showReasoning && color
              }
            ] : []),
            ...(message?.readOnly ? [] : [
              {
                label: 'Delete',
                onClick: () => setDeleteModal(message._id)
              }
            ])
          ]}
        />
      }
    </div>
  )
}

export default withRouter(AskVisoChatMessage)